import { useState } from "react";
import { ChevronDown, Anchor, Shield, ShieldAlert } from "lucide-react";

const FLEET = [
    { name: "Foundry", tagline: "Recruitment Hub", url: "https://recruitment.bizboogie.com", Icon: Anchor, current: true },
    { name: "TechOps", tagline: "Technical Brand", url: "https://techops.bizboogie.com", Icon: Shield },
    { name: "TechOpsSA", tagline: "Technical Brand", url: "https://techopssa.bizboogie.com", Icon: ShieldAlert },
];

export default function ArmadaSwitcher() {
    const [open, setOpen] = useState(false);
    return (
        <div className="relative">
            <button
                data-testid="armada-switcher"
                onClick={() => setOpen(!open)}
                className="caption inline-flex items-center gap-2 rounded-full border border-white/5 bg-white/[0.03] px-3 py-1.5 transition-all hover:border-white/20"
                style={{ color: "var(--brand-accent)" }}
            >
                <span className="h-1.5 w-1.5 rounded-full" style={{ background: "var(--brand-accent)" }} />
                EIGOO Armada
                <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div
                    onMouseLeave={() => setOpen(false)}
                    data-testid="armada-menu"
                    className="absolute left-1/2 top-[calc(100%+8px)] z-50 w-[360px] -translate-x-1/2 rounded-md border border-white/10 bg-[#0A0A0A]/95 p-2 backdrop-blur-2xl sovereign-shadow"
                >
                    <div className="caption px-3 py-2 text-[#737373]">The Fleet · Three Hulls</div>
                    {FLEET.map(({ name, tagline, url, Icon, current }) => (
                        <a
                            key={name}
                            href={url}
                            target={current ? undefined : "_blank"}
                            rel={current ? undefined : "noopener noreferrer"}
                            data-testid={`armada-link-${name.toLowerCase()}`}
                            className="flex items-center gap-3 rounded-sm p-3 transition-all hover:bg-white/[0.04]"
                        >
                            <div
                                className="flex h-10 w-10 items-center justify-center rounded-sm border"
                                style={{ borderColor: "rgba(201,169,110,0.3)", color: "var(--brand-accent)" }}
                            >
                                <Icon size={18} />
                            </div>
                            <div className="flex-1">
                                <div className="font-serif text-lg leading-tight text-[#FAFAFA]">
                                    {name}
                                    {current && <span className="ml-2 caption text-[var(--brand-accent)]">CURRENT</span>}
                                </div>
                                <div className="caption text-[#737373]">{tagline}</div>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
